<!-- Иконка DocumentOutline: сохранённый рисунок из карточки мониторинга. -->
<template>
  <svg
    :width="size"
    :height="size"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="stroke"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path
      d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8l-5-5z"
    />
    <path d="M14 3v5h5" />
    <path d="M9 13h6M9 17h6" />
  </svg>
</template>

<script>
export default {
  name: "DocumentOutlineIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
